import React from 'react'
import styles from './Cell.module.scss'
import { CellProps } from './types'
import { IconMinusCircle, IconPlusCircle } from 'assets'
import { AvatarImage, Tag } from 'components/common'
import { AggregationValue } from './AggregationValue'

const CellComponent = (props: CellProps) => {
  const {
    cell: {
      text,
      description,
      image,
      tags,
      aggregationValue,
      aggregationEntity,
      moneyAmount,
      width,
      expandable,
      numberOfChildren = 0,
      style = {}
    },
    toggleExpand,
    expanded,
    paddingLeft
  } = props

  return (
    <div style={{ paddingLeft, ...style, width }}>
      {expandable && numberOfChildren > 0 && (expanded
        ? <IconMinusCircle onClick={toggleExpand} />
        : <IconPlusCircle onClick={toggleExpand} />)
      }

      {image &&
        <AvatarImage
          src={image}
          size={33}
          className={styles.image}
        />
      }

      {(text &&
        <div className={styles.text}><span>{text}</span><span>{description}</span></div>) ||
        (tags && tags.map((tag, i) => <Tag key={i} tag={tag} />)) ||
        (moneyAmount !== undefined && `$${moneyAmount.toFixed(2)}`) ||
        <AggregationValue
          value={aggregationValue}
          entity={aggregationEntity}
          showFrame={expanded}
        />
      }

      {expandable && !!numberOfChildren &&
        <div className={styles.numberOfChildren}>
          {numberOfChildren}
        </div>
      }
    </div>
  )
}

const Cell = CellComponent
export { Cell }
